export default function generateBlock(blockManager, editor) {
	const addTemplate1 = (opts = {}) => {
		const blockId = opts.id || `hero-16x9-${Math.random().toString(36).slice(2, 8)}`;
		const ns = opts.ns || `ns-${Math.random().toString(36).slice(2, 8)}`;
		const label =
			opts.label ||
			`
      <div class="bg-secondary h-8 mb-4 rounded text-dark">Template 1</div>
      <div>Doctor Right, Text Left</div>
    `;
		const category = opts.category || "Default Banner";
		const imgDoctor = opts.image || "https://cdn.promedik.com/dokter-banner.png";

		// CSS scoped via namespace - now included directly in HTML
		const html = `
      <style>
        [data-ns="${ns}"]{ position:relative; color:#fff; overflow:hidden }
        [data-ns="${ns}"] .hero__bg{
          position:relative; width:100%; aspect-ratio:16/9; max-height:619px; min-height:400px; margin-inline:auto; overflow:hidden;
          background:
            radial-gradient(120% 90% at 12% 38%, rgba(255,255,255,.10) 0%, rgba(255,255,255,0) 60%),
            linear-gradient(135deg, #1d8a82 0%, #0f766e 100%);
        }
        @supports not (aspect-ratio:16/9){
          [data-ns="${ns}"] .hero__bg{ height:0; padding-top:56.25% }
          @media (max-width:960px){
            [data-ns="${ns}"] .hero__bg{ padding-top:56.25%; min-height:0; height:0 }
          }
          @media (max-width:520px){
            [data-ns="${ns}"] .hero__bg{ padding-top:56.25%; min-height:0; height:0 }
          }
        }

        /* Ornamen elemen nyata (bukan pseudo) */
        [data-ns="${ns}"] .ornamen-left{
          position:absolute; left:-12%; top:50%; transform:translateY(-35%);
          width:60%; height:100%;
          background:radial-gradient(circle at 0% 65%, rgba(255,255,255,.12) 0 40%, transparent 42%);
          mix-blend-mode:soft-light; pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-left-2{
          position:absolute; left:-18%; top:20%; 
          width:45%; height:60%;
          background:radial-gradient(ellipse at 10% 50%, rgba(255,255,255,.08) 0 35%, transparent 40%);
          mix-blend-mode:overlay; pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-left-3{
          position:absolute; left:-8%; bottom:10%; 
          width:50%; height:40%;
          background:linear-gradient(45deg, rgba(255,255,255,.06) 0%, transparent 60%);
          mix-blend-mode:soft-light; pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-circle-left{
          position:absolute; left:-12%; top:25%;
          width:min(45vmin,400px); height:min(45vmin,400px);
          border-radius:50%;
          background:radial-gradient(circle closest-side, rgba(255,255,255,.15) 0%, rgba(255,255,255,.08) 45%, rgba(255,255,255,0) 70%);
          box-shadow:inset 25px -25px 80px rgba(0,0,0,.15), inset -20px 20px 60px rgba(255,255,255,.08);
          pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-right{
          position:absolute; right:-10%; bottom:-30%;
          width:min(78vmin,880px); height:min(78vmin,880px);
          border-radius:50%;
          background:radial-gradient(circle closest-side, rgba(255,255,255,.20) 0%, rgba(255,255,255,.10) 45%, rgba(255,255,255,0) 70%);
          box-shadow:inset -50px -50px 150px rgba(0,0,0,.18), inset 40px 40px 100px rgba(255,255,255,.10);
          pointer-events:none; display:block;
        }

        [data-ns="${ns}"] .hero__inner{
          position:absolute; top:0; bottom:0; left:20px; right:20px; max-width:min(1200px,90vw); margin:auto;
          padding:0 clamp(48px,8vw,96px);
          display:grid; grid-template-columns:1.2fr 0.8fr; align-items:center; gap:clamp(8px,1.5vw,16px);
          min-height:100%;
        }
        [data-ns="${ns}"] .hero__title{ margin:0 0 10px; font-family:'Poppins',sans-serif; font-weight:800; line-height:1.1; font-size:clamp(20px,3.5vw,36px) }
        [data-ns="${ns}"] .hero__desc{ margin:0 0 clamp(12px,1.5vw,18px); max-width:50ch; font-family:'Poppins',sans-serif; font-size:clamp(12px,1.4vw,16px); color:rgba(255,255,255,.92) }
        [data-ns="${ns}"] .btn{ display:inline-block; background:#fff; color:#0f172a; padding:10px 20px; border-radius:999px; font-family:'Poppins',sans-serif; font-weight:600; font-size:clamp(12px,1.2vw,14px) }

        [data-ns="${ns}"] .hero__content{ grid-column:1; display:flex; flex-direction:column; justify-content:center; align-items:flex-start }
        [data-ns="${ns}"] .hero__figure{ grid-column:2; position:absolute; right:40%; bottom:0; display:flex; justify-content:center; align-items:flex-end; height:100% }
        [data-ns="${ns}"] .hero__img{ width:min(350px,42vw); max-width:100%; height:auto; max-height:85%; object-fit:contain; filter:drop-shadow(0 20px 35px rgba(0,0,0,.25)) }
        [data-ns="${ns}"] .hero__img{ width:min(350px,42vw); max-width:100%; height:auto; max-height:85%; object-fit:contain; filter:drop-shadow(0 20px 35px rgba(0,0,0,.25)) }

        /* Tablet */
        @media (max-width:960px){
          [data-ns="${ns}"] .hero__bg{ aspect-ratio:16/9; min-height:300px }
          [data-ns="${ns}"] .hero__inner{ grid-template-columns:1.5fr 1fr; align-items:center; justify-items:start; text-align:left; gap:12px; padding:0 clamp(24px,5vw,48px) }
          [data-ns="${ns}"] .hero__figure{ right:30%; bottom:0; justify-content:center; align-items:flex-end; height:100% }
          [data-ns="${ns}"] .hero__img{ width:min(200px,35vw); max-height:75% }
          [data-ns="${ns}"] .ornamen-right{ right:-22%; bottom:-36%; width:min(92vmin,740px); height:min(92vmin,740px) }
        }
        /* Ponsel kecil */
        @media (max-width:520px){
          [data-ns="${ns}"] .hero__bg{ aspect-ratio:16/9; height:240px; max-height:none }
          /* Grid: title full-width on row 1; row 2 shows text left, image overlays on right */
          [data-ns="${ns}"] .hero__inner{ top:0; bottom:0; left:10px; right:10px; padding:clamp(6px,2vw,12px) clamp(6px,2vw,12px) 0 clamp(6px,2vw,12px); padding-top:calc(var(--mobile-navbar-space, 56px) + var(--mobile-content-offset, 16px) + clamp(6px,2vw,12px)); display:grid; grid-template-columns:1fr min(110px,28vw); grid-template-rows:auto 1fr; gap:8px; align-items:start; height:100% }
          /* Content spans both rows; lowest layer in stacking order (below image and CTA) */
          [data-ns="${ns}"] .hero__content{ grid-column:1 / -1; grid-row:1 / 3; position:relative; display:flex; flex-direction:column; justify-content:center; z-index:auto; margin-top:6px }
          [data-ns="${ns}"] .hero__title{ font-size:clamp(13px,3.8vw,17px); line-height:1.1; margin-bottom:10px; width:100%; margin-top: 25px }
          [data-ns="${ns}"] .hero__title br{ display:initial }
          /* Allow text width to extend; no right-side reservation so it can partially sit under the image visually */
          [data-ns="${ns}"] .hero__desc{ font-size:clamp(10px,2.8vw,12px); line-height:1.3; max-width:min(42ch, 100%); margin-bottom:12px; display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; text-overflow:ellipsis }
          /* Button on topmost layer */
          [data-ns="${ns}"] .btn{ padding:6px 12px; font-size:clamp(10px,2.5vw,11px); margin-top:10px; position:relative; z-index:3 }
          /* Place image absolutely at bottom-right, above content to overlap button like the mock */
          [data-ns="${ns}"] .hero__figure{ position:absolute; right:clamp(8px,2vw,12px); bottom:0; display:flex; justify-content:center; align-items:flex-end; height:auto; z-index:2 }
          [data-ns="${ns}"] .hero__img{ width:min(130px,34vw); height:auto; display:block }
        }
        /* Viewport pendek */
        @media (max-height:619px){
          [data-ns="${ns}"] .hero__bg{ max-height:100vh }
        }
      </style>
      <section class="gjs-hero" data-ns="${ns}">
        <div class="hero__bg">
          <span class="ornamen-left" aria-hidden="true"></span>
          <span class="ornamen-left-2" aria-hidden="true"></span>
          <span class="ornamen-left-3" aria-hidden="true"></span>
          <span class="ornamen-circle-left" aria-hidden="true"></span>
          <span class="ornamen-right" aria-hidden="true"></span>
          <div class="hero__inner">
            <div class="hero__figure">
              <img class="hero__img" alt="Dokter" src="${imgDoctor}"/>
            </div>
            <div class="hero__content">
              <h1 class="hero__title">Jadwalkan Konsultasi Online Dengan Dokter Favoritmu</h1>
              <p class="hero__desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut</p>
              <a href="#" class="btn">Lihat detail</a>
            </div>
          </div>
        </div>
      </section>
    `;

		blockManager.add(blockId, {id: blockId, label, category, content: html});

		return {id: blockId, ns};
	};

	// Daftarkan hero isolated sebagai block utama
	addTemplate1({
		id: "hero-16x9-isolated",
		label: `
      <div class="bg-secondary h-8 mb-4 rounded text-dark">Template 1</div>
      <div>Doctor Right, Text Left</div>
    `,
		category: "Default Banner",
		image: "https://cdn.promedik.com/dokter-banner.png",
	});

	// Template 2: Doctor image on left, text content on right starting from middle
	const addTemplate2 = (opts = {}) => {
		const blockId = opts.id || `hero-left-img-${Math.random().toString(36).slice(2, 8)}`;
		const ns = opts.ns || `ns-${Math.random().toString(36).slice(2, 8)}`;
		const label =
			opts.label ||
			`
      <div class="bg-secondary h-8 mb-4 rounded text-dark">Template 2</div>
      <div>Doctor Left, Text Right</div>
    `;
		const category = opts.category || "Default Banner";
		const imgDoctor = opts.image || "https://cdn.promedik.com/dokter-banner.png";

		// CSS scoped via namespace - image on left, text on right starting from middle
		const html = `
      <style>
        [data-ns="${ns}"]{ position:relative; color:#fff; overflow:hidden }
        [data-ns="${ns}"] .hero__bg{
          position:relative; width:100%; aspect-ratio:16/9; max-height:619px; min-height:400px; margin-inline:auto; overflow:hidden;
          background:
            radial-gradient(120% 90% at 88% 38%, rgba(255,255,255,.10) 0%, rgba(255,255,255,0) 60%),
            linear-gradient(225deg, #1d8a82 0%, #0f766e 100%);
        }
        @supports not (aspect-ratio:16/9){
          [data-ns="${ns}"] .hero__bg{ height:0; padding-top:56.25% }
          @media (max-width:960px){
            [data-ns="${ns}"] .hero__bg{ padding-top:56.25%; min-height:0; height:0 }
          }
          @media (max-width:520px){
            [data-ns="${ns}"] .hero__bg{ padding-top:56.25%; min-height:0; height:0 }
          }
        }

        /* Ornamen elemen - mirrored for left layout */
        [data-ns="${ns}"] .ornamen-left{
          position:absolute; right:-18%; top:50%; transform:translateY(-35%);
          width:60%; height:100%;
          background:radial-gradient(circle at 100% 65%, rgba(255,255,255,.12) 0 40%, transparent 42%);
          mix-blend-mode:soft-light; pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-left-2{
          position:absolute; left:-25%; top:20%; 
          width:45%; height:60%;
          background:radial-gradient(ellipse at 10% 50%, rgba(255,255,255,.08) 0 35%, transparent 40%);
          mix-blend-mode:overlay; pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-left-3{
          position:absolute; left:-15%; bottom:10%; 
          width:50%; height:40%;
          background:linear-gradient(45deg, rgba(255,255,255,.06) 0%, transparent 60%);
          mix-blend-mode:soft-light; pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-circle-left{
          position:absolute; left:-20%; top:25%;
          width:min(45vmin,400px); height:min(45vmin,400px);
          border-radius:50%;
          background:radial-gradient(circle closest-side, rgba(255,255,255,.15) 0%, rgba(255,255,255,.08) 45%, rgba(255,255,255,0) 70%);
          box-shadow:inset 25px -25px 80px rgba(0,0,0,.15), inset -20px 20px 60px rgba(255,255,255,.08);
          pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-right{
          position:absolute; left:-10%; bottom:-30%;
          width:min(78vmin,880px); height:min(78vmin,880px);
          border-radius:50%;
          background:radial-gradient(circle closest-side, rgba(255,255,255,.20) 0%, rgba(255,255,255,.10) 45%, rgba(255,255,255,0) 70%);
          box-shadow:inset 50px -50px 150px rgba(0,0,0,.18), inset -40px 40px 100px rgba(255,255,255,.10);
          pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-ellipse-1{
          position:absolute; right:-30%; top:15%; 
          width:40%; height:70%;
          border-radius:50%;
          background:radial-gradient(ellipse at 80% 40%, rgba(255,255,255,.06) 0 30%, transparent 35%);
          mix-blend-mode:soft-light; pointer-events:none; display:block;
          transform:rotate(-15deg);
        }
        [data-ns="${ns}"] .ornamen-ellipse-2{
          position:absolute; left:-35%; top:40%; 
          width:50%; height:35%;
          border-radius:50%;
          background:radial-gradient(ellipse at 20% 60%, rgba(255,255,255,.05) 0 40%, transparent 45%);
          mix-blend-mode:soft-light; pointer-events:none; display:block;
          transform:rotate(25deg);
        }
        [data-ns="${ns}"] .ornamen-ellipse-3,
        [data-ns="${ns}"] .ornamen-ellipse-4,
        [data-ns="${ns}"] .ornamen-ellipse-5{
          display:none;
        }

        [data-ns="${ns}"] .hero__inner{
          position:absolute; inset:20px; max-width:min(1200px,90vw); margin:auto;
          padding:clamp(24px,5vw,48px) clamp(32px,6vw,64px);
          display:grid; grid-template-columns:1fr 1fr; align-items:center; gap:clamp(8px,1.5vw,16px);
          height:calc(100% - 40px);
        }

        /* Text content positioned from middle */
        [data-ns="${ns}"] .hero__content{
          display:flex; flex-direction:column; justify-content:center; align-items:flex-start;
          padding-left:clamp(20px,4vw,60px); text-align:left;
        }
        
        [data-ns="${ns}"] .hero__title{ margin:0 0 10px; font-family:'Poppins',sans-serif; font-weight:800; line-height:1.1; font-size:clamp(20px,3.5vw,36px) }
        [data-ns="${ns}"] .hero__desc{ margin:0 0 clamp(12px,1.5vw,18px); max-width:50ch; font-family:'Poppins',sans-serif; font-size:clamp(12px,1.4vw,16px); color:rgba(255,255,255,.92) }
        [data-ns="${ns}"] .btn{ display:inline-block; background:#fff; color:#0f172a; padding:10px 20px; border-radius:999px; font-family:'Poppins',sans-serif; font-weight:600; font-size:clamp(12px,1.2vw,14px) }

        [data-ns="${ns}"] .hero__figure{ display:flex; justify-content:flex-end; align-items:center; height:100%; position:relative }
        [data-ns="${ns}"] .hero__img{ width:min(480px,52vw); max-width:100%; height:auto; max-height:90%; object-fit:contain; filter:drop-shadow(0 20px 35px rgba(0,0,0,.25)); position:relative; z-index:2 }

        /* Tablet */
        @media (max-width:960px){
          [data-ns="${ns}"] .hero__bg{ aspect-ratio:16/9; min-height:300px }
          [data-ns="${ns}"] .hero__inner{ grid-template-columns:1fr 1fr; align-items:center; justify-items:start; text-align:left; gap:12px }
          [data-ns="${ns}"] .hero__content{ padding-left:clamp(10px,2vw,30px) }
          [data-ns="${ns}"] .hero__figure{ justify-content:center; height:100% }
          [data-ns="${ns}"] .hero__img{ width:min(280px,48vw); max-height:85% }
          [data-ns="${ns}"] .ornamen-right{ left:-22%; bottom:-36%; width:min(92vmin,740px); height:min(92vmin,740px) }
        }
        /* Ponsel kecil */
        @media (max-width:520px){
          [data-ns="${ns}"] .hero__bg{ aspect-ratio:16/9; height:240px; max-height:none }
          /* Grid: title full-width on row 1; row 2 image left + text right */
          [data-ns="${ns}"] .hero__inner{ top:0; bottom:0; left:2px; right:10px; padding:clamp(2px,1.2vw,6px) clamp(6px,2vw,12px) 0 clamp(6px,2vw,12px); padding-top:calc(var(--mobile-navbar-space, 56px) + var(--mobile-content-offset, 16px) + clamp(13px,3.4vw,22px)); display:grid; grid-template-columns:min(110px,28vw) 1fr; grid-template-rows:auto 1fr; gap:5px; align-items:start; height:100% }
          /* Content spans rows; overlap ~30% of image width */
          [data-ns="${ns}"] .hero__content{ grid-column:1 / -1; grid-row:1 / 3; position:relative; display:flex; flex-direction:column; justify-content:flex-start; padding-left:calc(min(110px,28vw) * 0.7); margin-top:10px; z-index:3 }
          [data-ns="${ns}"] .hero__title{ font-size:clamp(15px,4.3vw,19px); line-height:1.1; margin-bottom:10px; width:100%; margin-top:25px }
          [data-ns="${ns}"] .hero__title br{ display:initial }
          /* Tighten lines; container already offsets to the right of image */
          [data-ns="${ns}"] .hero__desc{ font-size:clamp(10px,2.8vw,12px); line-height:1.3; margin-bottom:12px; display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; text-overflow:ellipsis }
          [data-ns="${ns}"] .btn{ padding:6px 12px; font-size:clamp(10px,2.5vw,11px); margin-top:6px; align-self:flex-start }
          /* Place image absolutely at bottom-left so it always touches banner bottom */
          [data-ns="${ns}"] .hero__figure{ position:absolute; left:clamp(8px,2vw,12px); bottom:0; display:flex; justify-content:center; align-items:flex-end; height:auto; z-index:1 }
          [data-ns="${ns}"] .hero__img{ width:min(110px,28vw); height:auto; display:block }
        }
        /* Viewport pendek */
        @media (max-height:619px){
          [data-ns="${ns}"] .hero__bg{ max-height:100vh }
        }
      </style>
      <section class="gjs-hero" data-ns="${ns}">
        <div class="hero__bg">
          <span class="ornamen-left" aria-hidden="true"></span>
          <span class="ornamen-left-2" aria-hidden="true"></span>
          <span class="ornamen-left-3" aria-hidden="true"></span>
          <span class="ornamen-circle-left" aria-hidden="true"></span>
          <span class="ornamen-right" aria-hidden="true"></span>
          <span class="ornamen-ellipse-1" aria-hidden="true"></span>
          <span class="ornamen-ellipse-2" aria-hidden="true"></span>
          <span class="ornamen-ellipse-3" aria-hidden="true"></span>
          <span class="ornamen-ellipse-4" aria-hidden="true"></span>
          <span class="ornamen-ellipse-5" aria-hidden="true"></span>
          <div class="hero__inner">
            <div class="hero__figure">
              <img class="hero__img" alt="Dokter" src="${imgDoctor}"/>
            </div>
            <div class="hero__content">
              <h1 class="hero__title">Konsultasi Terpercaya<br/>Dengan Dokter Profesional</h1>
              <p class="hero__desc">Dapatkan layanan kesehatan terbaik dengan konsultasi online bersama dokter berpengalaman kapan saja</p>
              <a href="#" class="btn">Mulai konsultasi</a>
            </div>
          </div>
        </div>
      </section>
    `;

		blockManager.add(blockId, {id: blockId, label, category, content: html});

		return {id: blockId, ns};
	};

	// Template 3: Center-aligned text with doctor image behind
	const addTemplate3 = (opts = {}) => {
		const blockId = opts.id || `hero-center-${Math.random().toString(36).slice(2, 8)}`;
		const ns = opts.ns || `ns-${Math.random().toString(36).slice(2, 8)}`;
		const label =
			opts.label ||
			`
      <div class="bg-secondary h-8 mb-4 rounded text-dark">Template 3</div>
      <div>Center Text, Doctor Behind</div>
    `;
		const category = opts.category || "Default Banner";
		const imgDoctor = opts.image || "https://cdn.promedik.com/dokter-banner.png";

		// CSS scoped via namespace - center text with doctor behind
		const html = `
      <style>
        [data-ns="${ns}"]{ position:relative; color:#fff; overflow:hidden }
        [data-ns="${ns}"] .hero__bg{
          position:relative; width:100%; aspect-ratio:16/9; max-height:619px; min-height:400px; margin-inline:auto; overflow:hidden;
          background:
            radial-gradient(120% 90% at 88% 38%, rgba(255,255,255,.10) 0%, rgba(255,255,255,0) 60%),
            linear-gradient(225deg, #1d8a82 0%, #0f766e 100%);
        }
        [data-ns="${ns}"] .hero__bg::before{
          content:''; position:absolute; inset:0; z-index:1;
          background:linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.4) 60%, rgba(0,0,0,0.1) 90%, transparent 100%);
          pointer-events:none;
        }
        @supports not (aspect-ratio:16/9){
          [data-ns="${ns}"] .hero__bg{ height:0; padding-top:56.25% }
          @media (max-width:960px){
            [data-ns="${ns}"] .hero__bg{ padding-top:56.25%; min-height:0; height:0 }
          }
          @media (max-width:520px){
            [data-ns="${ns}"] .hero__bg{ padding-top:56.25%; min-height:0; height:0 }
          }
        }

        /* Ornamen elemen */
        [data-ns="${ns}"] .ornamen-left{
          position:absolute; left:-18%; top:50%; transform:translateY(-35%);
          width:60%; height:100%;
          background:radial-gradient(circle at 0% 65%, rgba(255,255,255,.06) 0 40%, transparent 42%);
          mix-blend-mode:soft-light; pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-left-2{
          position:absolute; left:-25%; top:20%; 
          width:45%; height:60%;
          background:radial-gradient(ellipse at 10% 50%, rgba(255,255,255,.04) 0 35%, transparent 40%);
          mix-blend-mode:overlay; pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-left-3{
          position:absolute; left:-15%; bottom:10%; 
          width:50%; height:40%;
          background:linear-gradient(45deg, rgba(255,255,255,.03) 0%, transparent 60%);
          mix-blend-mode:soft-light; pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-circle-left{
          position:absolute; left:-20%; top:25%;
          width:min(45vmin,400px); height:min(45vmin,400px);
          border-radius:50%;
          background:radial-gradient(circle closest-side, rgba(255,255,255,.08) 0%, rgba(255,255,255,.04) 45%, rgba(255,255,255,0) 70%);
          box-shadow:inset 20px -20px 60px rgba(0,0,0,.08), inset -15px 15px 40px rgba(255,255,255,.04);
          pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-right{
          position:absolute; right:-10%; bottom:-30%;
          width:min(78vmin,880px); height:min(78vmin,880px);
          border-radius:50%;
          background:radial-gradient(circle closest-side, rgba(255,255,255,.20) 0%, rgba(255,255,255,.10) 45%, rgba(255,255,255,0) 70%);
          box-shadow:inset -50px -50px 150px rgba(0,0,0,.18), inset 40px 40px 100px rgba(255,255,255,.10);
          pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-ellipse-1{
          position:absolute; left:-25%; top:20%; 
          width:45%; height:60%;
          border-radius:50%;
          background:radial-gradient(ellipse at 30% 50%, rgba(255,255,255,.06) 0 35%, transparent 40%);
          mix-blend-mode:soft-light; pointer-events:none; display:block;
          transform:rotate(20deg);
        }
        [data-ns="${ns}"] .ornamen-ellipse-2{
          position:absolute; right:-30%; top:30%; 
          width:40%; height:50%;
          border-radius:50%;
          background:radial-gradient(ellipse at 70% 40%, rgba(255,255,255,.05) 0 40%, transparent 45%);
          mix-blend-mode:soft-light; pointer-events:none; display:block;
          transform:rotate(-25deg);
        }
        [data-ns="${ns}"] .ornamen-ellipse-3,
        [data-ns="${ns}"] .ornamen-ellipse-4,
        [data-ns="${ns}"] .ornamen-ellipse-5{
          display:none;
        }

        [data-ns="${ns}"] .hero__inner{
          position:absolute; inset:0; max-width:min(1200px,90vw); margin:auto;
          padding:clamp(16px,3vw,32px);
          display:flex; flex-direction:column; justify-content:center; align-items:center;
          height:100%; text-align:center; z-index:2;
        }
        
        /* Doctor image positioned behind text */
        [data-ns="${ns}"] .hero__figure{
          position:absolute; right:clamp(20px,8vw,120px); top:0; bottom:0; 
          display:flex; justify-content:center; align-items:flex-end;
          z-index:2; opacity:0.7; width:min(320px,28vw);
        }
        [data-ns="${ns}"] .hero__img{
          width:100%; height:auto; max-height:none;
          object-fit:contain; 
          filter:drop-shadow(0 20px 35px rgba(0,0,0,.15));
          align-self:flex-end;
        }
        
        /* Text content centered */
        [data-ns="${ns}"] .hero__content{
          position:relative; z-index:2; max-width:600px;
          display:flex; flex-direction:column; justify-content:center; align-items:center;
        }
        
        [data-ns="${ns}"] .hero__title{ margin:0 0 16px; font-family:'Poppins',sans-serif; font-weight:800; line-height:1.1; font-size:clamp(24px,4vw,42px); text-align:center }
        [data-ns="${ns}"] .hero__desc{ margin:0 0 clamp(16px,2vw,24px); max-width:50ch; font-family:'Poppins',sans-serif; font-size:clamp(14px,1.6vw,18px); color:rgba(255,255,255,.92); text-align:center }
        [data-ns="${ns}"] .btn{ display:inline-block; background:#fff; color:#0f172a; padding:12px 24px; border-radius:999px; font-family:'Poppins',sans-serif; font-weight:600; font-size:clamp(13px,1.3vw,15px) }

        /* Tablet */
        @media (max-width:960px){
          [data-ns="${ns}"] .hero__bg{ aspect-ratio:16/9; min-height:300px }
          [data-ns="${ns}"] .hero__inner{ padding:clamp(12px,2.5vw,24px) }
          [data-ns="${ns}"] .hero__figure{ right:clamp(15px,6vw,80px); top:0; bottom:0; opacity:0.5; width:min(250px,26vw) }
          [data-ns="${ns}"] .hero__img{ width:100%; height:auto; object-fit:contain; align-self:flex-end }
          [data-ns="${ns}"] .hero__content{ max-width:500px }
          [data-ns="${ns}"] .ornamen-right{ right:-22%; bottom:-36%; width:min(92vmin,740px); height:min(92vmin,740px) }
        }
        
        /* Mobile */
        @media (max-width:520px){
          [data-ns="${ns}"] .hero__bg{ aspect-ratio:16/9; height:240px; max-height:none }
          [data-ns="${ns}"] .hero__inner{ inset:0; padding:clamp(8px,2vw,16px); padding-top:calc(var(--mobile-navbar-space, 56px) + var(--mobile-content-offset, 16px) + clamp(8px,2vw,16px)) }
          [data-ns="${ns}"] .hero__figure{ right:clamp(5px,3vw,20px); top:0; bottom:0; opacity:0.4; width:min(160px,22vw) }
          [data-ns="${ns}"] .hero__img{ width:100%; height:auto; object-fit:contain; align-self:flex-end }
          [data-ns="${ns}"] .hero__content{ max-width:280px }
          [data-ns="${ns}"] .hero__title{ font-size:clamp(18px,5vw,24px); margin-bottom:10px; margin-top:-40px }
          [data-ns="${ns}"] .hero__desc{ font-size:clamp(11px,3vw,14px); line-height:1.3; margin-bottom:12px }
          [data-ns="${ns}"] .btn{ padding:8px 16px; font-size:clamp(11px,2.8vw,13px) }
        }
        
        /* Viewport pendek */
        @media (max-height:619px){
          [data-ns="${ns}"] .hero__bg{ max-height:100vh }
        }
      </style>
      <section class="gjs-hero" data-ns="${ns}">
        <div class="hero__bg">
          <span class="ornamen-left" aria-hidden="true"></span>
          <span class="ornamen-left-2" aria-hidden="true"></span>
          <span class="ornamen-left-3" aria-hidden="true"></span>
          <span class="ornamen-circle-left" aria-hidden="true"></span>
          <span class="ornamen-right" aria-hidden="true"></span>
          <span class="ornamen-ellipse-1" aria-hidden="true"></span>
          <span class="ornamen-ellipse-2" aria-hidden="true"></span>
          <span class="ornamen-ellipse-3" aria-hidden="true"></span>
          <span class="ornamen-ellipse-4" aria-hidden="true"></span>
          <span class="ornamen-ellipse-5" aria-hidden="true"></span>
          <div class="hero__inner">
            <div class="hero__figure">
              <img class="hero__img" alt="Dokter" src="${imgDoctor}"/>
            </div>
            <div class="hero__content">
              <h1 class="hero__title">Konsultasi Terpercaya<br/>Dengan Dokter Profesional</h1>
              <p class="hero__desc">Dapatkan layanan kesehatan terbaik dengan konsultasi online bersama dokter berpengalaman kapan saja</p>
              <a href="#" class="btn">Mulai konsultasi</a>
            </div>
          </div>
        </div>
      </section>
    `;

		blockManager.add(blockId, {id: blockId, label, category, content: html});

		return {id: blockId, ns};
	};

	// Daftarkan template 2
	addTemplate2({
		id: "hero-16x9-left-image",
		label: `
      <div class="bg-secondary h-8 mb-4 rounded text-dark">Template 2</div>
      <div>Doctor Left, Text Right</div>
    `,
		category: "Default Banner",
		image: "https://cdn.promedik.com/dokter-banner.png",
	});

	// Daftarkan template 3
	addTemplate3({
		id: "hero-16x9-center-text",
		label: `
      <div class="bg-secondary h-8 mb-4 rounded text-dark">Template 3</div>
      <div>Center Text, Doctor Behind</div>
    `,
		category: "Default Banner",
		image: "https://cdn.promedik.com/dokter-banner.png",
	});

	// Template 4: Like Template 1 but with gradient
	const addTemplate4 = (opts = {}) => {
		const blockId = opts.id || `hero-gradient-right-${Math.random().toString(36).slice(2, 8)}`;
		const ns = opts.ns || `ns-${Math.random().toString(36).slice(2, 8)}`;
		const label =
			opts.label ||
			`
      <div class="bg-secondary h-8 mb-4 rounded text-dark">Template 4</div>
      <div>Text Left, Doctor Right + Gradient</div>
    `;
		const category = opts.category || "Default Banner";
		const imgDoctor = opts.image || "https://cdn.promedik.com/dokter-banner.png";

		// CSS scoped via namespace - text left, doctor right with gradient
		const html = `
      <style>
        [data-ns="${ns}"]{ position:relative; color:#fff; overflow:hidden }
        [data-ns="${ns}"] .hero__bg{
          position:relative; width:100%; aspect-ratio:16/9; max-height:619px; min-height:400px; margin-inline:auto; overflow:hidden;
          background:
            radial-gradient(120% 90% at 88% 38%, rgba(255,255,255,.10) 0%, rgba(255,255,255,0) 60%),
            linear-gradient(225deg, #1d8a82 0%, #0f766e 100%);
        }
        [data-ns="${ns}"] .hero__bg::before{
          content:''; position:absolute; inset:0; z-index:2;
            background:linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.4) 60%, rgba(0,0,0,0.1) 90%, transparent 100%);
          pointer-events:none;
        }
        @supports not (aspect-ratio:16/9){
          [data-ns="${ns}"] .hero__bg{ height:0; padding-top:56.25% }
          @media (max-width:960px){
            [data-ns="${ns}"] .hero__bg{ padding-top:56.25%; min-height:0; height:0 }
          }
          @media (max-width:520px){
            [data-ns="${ns}"] .hero__bg{ padding-top:56.25%; min-height:0; height:0 }
          }
        }

        /* Ornamen elemen */
        [data-ns="${ns}"] .ornamen-left{
          position:absolute; left:-12%; top:50%; transform:translateY(-35%);
          width:60%; height:100%;
          background:radial-gradient(circle at 0% 65%, rgba(255,255,255,.12) 0 40%, transparent 42%);
          mix-blend-mode:soft-light; pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-left-2{
          position:absolute; left:-18%; top:20%; 
          width:45%; height:60%;
          background:radial-gradient(ellipse at 10% 50%, rgba(255,255,255,.08) 0 35%, transparent 40%);
          mix-blend-mode:overlay; pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-left-3{
          position:absolute; left:-8%; bottom:10%; 
          width:50%; height:40%;
          background:linear-gradient(45deg, rgba(255,255,255,.06) 0%, transparent 60%);
          mix-blend-mode:soft-light; pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-circle-left{
          position:absolute; left:-12%; top:25%;
          width:min(45vmin,400px); height:min(45vmin,400px);
          border-radius:50%;
          background:radial-gradient(circle closest-side, rgba(255,255,255,.15) 0%, rgba(255,255,255,.08) 45%, rgba(255,255,255,0) 70%);
          box-shadow:inset 25px -25px 80px rgba(0,0,0,.15), inset -20px 20px 60px rgba(255,255,255,.08);
          pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-right{
          position:absolute; right:-10%; bottom:-30%;
          width:min(78vmin,880px); height:min(78vmin,880px);
          border-radius:50%;
          background:radial-gradient(circle closest-side, rgba(255,255,255,.20) 0%, rgba(255,255,255,.10) 45%, rgba(255,255,255,0) 70%);
          box-shadow:inset -50px -50px 150px rgba(0,0,0,.18), inset 40px 40px 100px rgba(255,255,255,.10);
          pointer-events:none; display:block;
        }

        [data-ns="${ns}"] .hero__inner{
          position:absolute; top:0; bottom:0; left:20px; right:20px; max-width:min(1200px,90vw); margin:auto;
          padding:0 clamp(48px,8vw,96px);
          display:grid; grid-template-columns:1.2fr 0.8fr; align-items:center; gap:clamp(8px,1.5vw,16px);
          min-height:100%; z-index:auto;
        }
        
  [data-ns="${ns}"] .hero__content{ grid-column:1; display:flex; flex-direction:column; justify-content:center; align-items:flex-start; position:relative; z-index:3 }
        [data-ns="${ns}"] .hero__title{ margin:0 0 10px; font-family:'Poppins',sans-serif; font-weight:800; line-height:1.1; font-size:clamp(20px,3.5vw,36px) }
        [data-ns="${ns}"] .hero__desc{ margin:0 0 clamp(12px,1.5vw,18px); max-width:50ch; font-family:'Poppins',sans-serif; font-size:clamp(12px,1.4vw,16px); color:rgba(255,255,255,.92) }
        [data-ns="${ns}"] .btn{ display:inline-block; background:#fff; color:#0f172a; padding:10px 20px; border-radius:999px; font-family:'Poppins',sans-serif; font-weight:600; font-size:clamp(12px,1.2vw,14px) }

  [data-ns="${ns}"] .hero__figure{ grid-column:2; position:absolute; right:40%; bottom:0; display:flex; justify-content:center; align-items:flex-end; height:100%; z-index:1 }
  [data-ns="${ns}"] .hero__img{ width:min(350px,42vw); max-width:100%; height:auto; max-height:85%; object-fit:contain; filter:drop-shadow(0 20px 35px rgba(0,0,0,.25)); opacity:.85 }

        /* Tablet */
        @media (max-width:960px){
          [data-ns="${ns}"] .hero__bg{ aspect-ratio:16/9; min-height:300px }
          [data-ns="${ns}"] .hero__inner{ grid-template-columns:1.5fr 1fr; align-items:center; justify-items:start; text-align:left; gap:12px; padding:0 clamp(24px,5vw,48px) }
          [data-ns="${ns}"] .hero__figure{ right:30%; bottom:0; justify-content:center; align-items:flex-end; height:100% }
          [data-ns="${ns}"] .hero__img{ width:min(200px,35vw); max-height:75% }
          [data-ns="${ns}"] .ornamen-right{ right:-22%; bottom:-36%; width:min(92vmin,740px); height:min(92vmin,740px) }
        }
        /* Ponsel kecil */
        @media (max-width:520px){
          [data-ns="${ns}"] .hero__bg{ aspect-ratio:16/9; height:240px; max-height:none }
          /* Gradient overlay above image, below text */
          [data-ns="${ns}"] .hero__bg::before{ z-index:2 }
            /* Layout like Template 1: title full-width row 1; figure overlaps bottom-right visually but stays under gradient */
            [data-ns="${ns}"] .hero__inner{ top:0; bottom:0; left:10px; right:10px; padding:clamp(6px,2vw,12px) clamp(6px,2vw,12px) 0 clamp(6px,2vw,12px); padding-top:calc(var(--mobile-navbar-space, 56px) + var(--mobile-content-offset, 16px) + clamp(6px,2vw,12px)); display:grid; grid-template-columns:1fr min(110px,28vw); grid-template-rows:auto 1fr; gap:8px; align-items:start; height:100%; z-index:3 }
            /* Text above gradient */
            [data-ns="${ns}"] .hero__content{ grid-column:1 / -1; grid-row:1 / 3; position:relative; display:flex; flex-direction:column; justify-content:center; z-index:3; margin-top:6px }
            [data-ns="${ns}"] .hero__title{ font-size:clamp(13px,3.8vw,17px); line-height:1.1; margin-bottom:10px; width:100%; margin-top:25px }
            [data-ns="${ns}"] .hero__title br{ display:initial }
            [data-ns="${ns}"] .hero__desc{ font-size:clamp(10px,2.8vw,12px); line-height:1.3; max-width:min(42ch, 100%); margin-bottom:12px; display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; text-overflow:ellipsis }
            [data-ns="${ns}"] .btn{ padding:6px 12px; font-size:clamp(10px,2.5vw,11px); margin-top:10px; position:relative; z-index:4 }
            /* Image under gradient */
            [data-ns="${ns}"] .hero__figure{ position:absolute; right:clamp(8px,2vw,12px); bottom:0; display:flex; justify-content:center; align-items:flex-end; height:auto; z-index:1 }
            [data-ns="${ns}"] .hero__img{ width:min(130px,34vw); height:auto; display:block; opacity:.65 }
          [data-ns="${ns}"] .hero__title{ font-size:clamp(16px,4.3vw,19px); line-height:1.1; margin-bottom:10px; width:100% }
          [data-ns="${ns}"] .hero__title br{ display:initial }
          [data-ns="${ns}"] .hero__desc{ font-size:clamp(10px,2.7vw,12px); line-height:1.3; margin-bottom:12px; max-width:52ch; display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; text-overflow:ellipsis }
          [data-ns="${ns}"] .btn{ padding:6px 12px; font-size:clamp(10px,2.5vw,11px); align-self:flex-start; margin-top:4px; z-index:4 }
          /* Doctor image absolute bottom-right under gradient */
          [data-ns="${ns}"] .hero__figure{ position:absolute; right:clamp(8px,2vw,12px); bottom:0; display:flex; justify-content:center; align-items:flex-end; height:auto; z-index:1 }
          [data-ns="${ns}"] .hero__img{ width:min(130px,34vw); height:auto; display:block; opacity:.65; will-change:opacity; -webkit-backface-visibility:hidden; transform:translateZ(0) }
        }
        /* Viewport pendek */
        @media (max-height:619px){
          [data-ns="${ns}"] .hero__bg{ max-height:100vh }
        }
      </style>
      <section class="gjs-hero" data-ns="${ns}">
        <div class="hero__bg">
          <span class="ornamen-left" aria-hidden="true"></span>
          <span class="ornamen-left-2" aria-hidden="true"></span>
          <span class="ornamen-left-3" aria-hidden="true"></span>
          <span class="ornamen-circle-left" aria-hidden="true"></span>
          <span class="ornamen-right" aria-hidden="true"></span>
          <div class="hero__inner">
            <div class="hero__figure">
              <img class="hero__img" alt="Dokter" src="${imgDoctor}"/>
            </div>
            <div class="hero__content">
              <h1 class="hero__title">Jadwalkan Konsultasi Online<br/>Dengan Dokter Favoritmu</h1>
              <p class="hero__desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut</p>
              <a href="#" class="btn">Lihat detail</a>
            </div>
          </div>
        </div>
      </section>
    `;

		blockManager.add(blockId, {id: blockId, label, category, content: html});

		return {id: blockId, ns};
	};

	// Template 5: Like Template 2 but with gradient
	const addTemplate5 = (opts = {}) => {
		const blockId = opts.id || `hero-gradient-left-${Math.random().toString(36).slice(2, 8)}`;
		const ns = opts.ns || `ns-${Math.random().toString(36).slice(2, 8)}`;
		const label =
			opts.label ||
			`
      <div class="bg-secondary h-8 mb-4 rounded text-dark">Template 5</div>
      <div>Doctor Left, Text Right + Gradient</div>
    `;
		const category = opts.category || "Default Banner";
		const imgDoctor = opts.image || "https://cdn.promedik.com/dokter-banner.png";

		// CSS scoped via namespace - doctor left, text right with gradient
		const html = `
      <style>
        [data-ns="${ns}"]{ position:relative; color:#fff; overflow:hidden }
        [data-ns="${ns}"] .hero__bg{
          position:relative; width:100%; aspect-ratio:16/9; max-height:619px; min-height:400px; margin-inline:auto; overflow:hidden;
          background:
            radial-gradient(120% 90% at 88% 38%, rgba(255,255,255,.10) 0%, rgba(255,255,255,0) 60%),
            linear-gradient(225deg, #1d8a82 0%, #0f766e 100%);
        }
        [data-ns="${ns}"] .hero__bg::before{
          content:''; position:absolute; inset:0; z-index:1;
          background:linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.4) 60%, rgba(0,0,0,0.1) 90%, transparent 100%);
          pointer-events:none;
        }
        @supports not (aspect-ratio:16/9){
          [data-ns="${ns}"] .hero__bg{ height:0; padding-top:56.25% }
          @media (max-width:960px){
            [data-ns="${ns}"] .hero__bg{ padding-top:56.25%; min-height:0; height:0 }
          }
          @media (max-width:520px){
            [data-ns="${ns}"] .hero__bg{ padding-top:56.25%; min-height:0; height:0 }
          }
        }

        /* Ornamen elemen - mirrored for left layout */
        [data-ns="${ns}"] .ornamen-left{
          position:absolute; right:-18%; top:50%; transform:translateY(-35%);
          width:60%; height:100%;
          background:radial-gradient(circle at 100% 65%, rgba(255,255,255,.06) 0 40%, transparent 42%);
          mix-blend-mode:soft-light; pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-left-2{
          position:absolute; left:-25%; top:20%; 
          width:45%; height:60%;
          background:radial-gradient(ellipse at 10% 50%, rgba(255,255,255,.04) 0 35%, transparent 40%);
          mix-blend-mode:overlay; pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-left-3{
          position:absolute; left:-15%; bottom:10%; 
          width:50%; height:40%;
          background:linear-gradient(45deg, rgba(255,255,255,.03) 0%, transparent 60%);
          mix-blend-mode:soft-light; pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-circle-left{
          position:absolute; left:-20%; top:25%;
          width:min(45vmin,400px); height:min(45vmin,400px);
          border-radius:50%;
          background:radial-gradient(circle closest-side, rgba(255,255,255,.08) 0%, rgba(255,255,255,.04) 45%, rgba(255,255,255,0) 70%);
          box-shadow:inset 20px -20px 60px rgba(0,0,0,.08), inset -15px 15px 40px rgba(255,255,255,.04);
          pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-right{
          position:absolute; left:-10%; bottom:-30%;
          width:min(78vmin,880px); height:min(78vmin,880px);
          border-radius:50%;
          background:radial-gradient(circle closest-side, rgba(255,255,255,.14) 0%, rgba(255,255,255,.06) 45%, rgba(255,255,255,0) 70%);
          box-shadow:inset 40px -40px 120px rgba(0,0,0,.12), inset -30px 30px 80px rgba(255,255,255,.06);
          pointer-events:none; display:block;
        }
        [data-ns="${ns}"] .ornamen-ellipse-1{
          position:absolute; right:-30%; top:15%; 
          width:40%; height:70%;
          border-radius:50%;
          background:radial-gradient(ellipse at 80% 40%, rgba(255,255,255,.06) 0 30%, transparent 35%);
          mix-blend-mode:soft-light; pointer-events:none; display:block;
          transform:rotate(-15deg);
        }
        [data-ns="${ns}"] .ornamen-ellipse-2{
          position:absolute; left:-35%; top:40%; 
          width:50%; height:35%;
          border-radius:50%;
          background:radial-gradient(ellipse at 20% 60%, rgba(255,255,255,.05) 0 40%, transparent 45%);
          mix-blend-mode:soft-light; pointer-events:none; display:block;
          transform:rotate(25deg);
        }
        [data-ns="${ns}"] .ornamen-ellipse-3,
        [data-ns="${ns}"] .ornamen-ellipse-4,
        [data-ns="${ns}"] .ornamen-ellipse-5{
          display:none;
        }
          transform:rotate(-30deg);
          box-shadow:inset 8px -8px 30px rgba(0,0,0,.08);
        }
        [data-ns="${ns}"] .ornamen-ellipse-4{
          position:absolute; left:-10%; top:60%; 
          width:30%; height:25%;
          border-radius:50%;
          background:radial-gradient(ellipse at 30% 70%, rgba(255,255,255,.16) 0 25%, transparent 30%);
          mix-blend-mode:screen; pointer-events:none; display:block;
          transform:rotate(45deg);
          opacity:0.6;
        }
        [data-ns="${ns}"] .ornamen-ellipse-5{
          position:absolute; right:-15%; top:35%; 
          width:25%; height:30%;
          border-radius:50%;
          background:radial-gradient(ellipse at 75% 25%, rgba(255,255,255,.14) 0 30%, transparent 35%);
          mix-blend-mode:screen; pointer-events:none; display:block;
          transform:rotate(-60deg);
          opacity:0.5;
        }

        [data-ns="${ns}"] .hero__inner{
          position:absolute; inset:20px; max-width:min(1200px,90vw); margin:auto;
          padding:clamp(24px,5vw,48px) clamp(32px,6vw,64px);
          display:grid; grid-template-columns:1fr 1fr; align-items:center; gap:clamp(8px,1.5vw,16px);
          height:calc(100% - 40px); z-index:auto;
        }
        
        /* Text content positioned from middle */
        [data-ns="${ns}"] .hero__content{
          display:flex; flex-direction:column; justify-content:center; align-items:flex-start;
          padding-left:clamp(20px,4vw,60px); text-align:left; position:relative; z-index:3;
        }
        
        [data-ns="${ns}"] .hero__title{ margin:0 0 10px; font-family:'Poppins',sans-serif; font-weight:800; line-height:1.1; font-size:clamp(20px,3.5vw,36px) }
        [data-ns="${ns}"] .hero__desc{ margin:0 0 clamp(12px,1.5vw,18px); max-width:50ch; font-family:'Poppins',sans-serif; font-size:clamp(12px,1.4vw,16px); color:rgba(255,255,255,.92) }
        [data-ns="${ns}"] .btn{ display:inline-block; background:#fff; color:#0f172a; padding:10px 20px; border-radius:999px; font-family:'Poppins',sans-serif; font-weight:600; font-size:clamp(12px,1.2vw,14px) }

  [data-ns="${ns}"] .hero__figure{ display:flex; justify-content:flex-end; align-items:center; height:100%; position:relative; z-index:1 }
  [data-ns="${ns}"] .hero__img{ width:min(480px,52vw); max-width:100%; height:auto; max-height:90%; object-fit:contain; filter:drop-shadow(0 20px 35px rgba(0,0,0,.25)); position:relative; z-index:1; opacity:.85 }

        /* Tablet */
        @media (max-width:960px){
          [data-ns="${ns}"] .hero__bg{ aspect-ratio:16/9; min-height:300px }
          [data-ns="${ns}"] .hero__inner{ grid-template-columns:1fr 1fr; align-items:center; justify-items:start; text-align:left; gap:12px }
          [data-ns="${ns}"] .hero__content{ padding-left:clamp(10px,2vw,30px) }
          [data-ns="${ns}"] .hero__figure{ justify-content:center; height:100% }
          [data-ns="${ns}"] .hero__img{ width:min(280px,48vw); max-height:85% }
          [data-ns="${ns}"] .ornamen-right{ left:-22%; bottom:-36%; width:min(92vmin,740px); height:min(92vmin,740px) }
        }
        /* Ponsel kecil */
        @media (max-width:520px){
          [data-ns="${ns}"] .hero__bg{ aspect-ratio:16/9; height:240px; max-height:none }
          [data-ns="${ns}"] .hero__bg::before{ z-index:2 }
          /* Grid: title full-width row 1; row 2 image left + text right */
          [data-ns="${ns}"] .hero__inner{ top:0; bottom:0; left:10px; right:10px; padding:clamp(6px,2vw,12px) clamp(6px,2vw,12px) 0 clamp(6px,2vw,12px); padding-top:calc(var(--mobile-navbar-space, 56px) + var(--mobile-content-offset, 16px) + clamp(6px,2vw,12px)); display:grid; grid-template-columns:min(100px,26vw) 1fr; grid-template-rows:auto 1fr; gap:8px; align-items:start; height:100%; z-index:auto }
          /* Vertically center text; overlap ~30% of image */
          [data-ns="${ns}"] .hero__content{ grid-column:1 / -1; grid-row:1 / 3; position:relative; display:flex; flex-direction:column; justify-content:center; align-items:flex-start; z-index:3; padding-left:calc(min(100px,26vw) * 0.7); margin-top:10px }
          [data-ns="${ns}"] .hero__title{ font-size:clamp(16px,4.5vw,20px); line-height:1.1; margin-bottom:10px; width:100%; margin-top:25px }
          [data-ns="${ns}"] .hero__title br{ display:initial }
          /* Left-aligned content after image column */
          [data-ns="${ns}"] .hero__desc{ font-size:clamp(10px,2.8vw,12px); line-height:1.3; margin-bottom:12px; display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; text-overflow:ellipsis }
          [data-ns="${ns}"] .btn{ padding:6px 12px; font-size:clamp(10px,2.5vw,11px); align-self:flex-start; margin-top:6px }
          /* Place image absolutely at bottom-left under gradient */
          [data-ns="${ns}"] .hero__figure{ position:absolute; left:clamp(8px,2vw,12px); bottom:0; display:flex; justify-content:center; align-items:flex-end; height:auto; z-index:1 }
          [data-ns="${ns}"] .hero__img{ width:min(100px,26vw); height:auto; display:block }
        }
        /* Viewport pendek */
        @media (max-height:619px){
          [data-ns="${ns}"] .hero__bg{ max-height:100vh }
        }
      </style>
      <section class="gjs-hero" data-ns="${ns}">
        <div class="hero__bg">
          <span class="ornamen-left" aria-hidden="true"></span>
          <span class="ornamen-left-2" aria-hidden="true"></span>
          <span class="ornamen-left-3" aria-hidden="true"></span>
          <span class="ornamen-circle-left" aria-hidden="true"></span>
          <span class="ornamen-right" aria-hidden="true"></span>
          <span class="ornamen-ellipse-1" aria-hidden="true"></span>
          <span class="ornamen-ellipse-2" aria-hidden="true"></span>
          <span class="ornamen-ellipse-3" aria-hidden="true"></span>
          <span class="ornamen-ellipse-4" aria-hidden="true"></span>
          <span class="ornamen-ellipse-5" aria-hidden="true"></span>
          <div class="hero__inner">
            <div class="hero__figure">
              <img class="hero__img" alt="Dokter" src="${imgDoctor}"/>
            </div>
            <div class="hero__content">
              <h1 class="hero__title">Konsultasi Terpercaya<br/>Dengan Dokter Profesional</h1>
              <p class="hero__desc">Dapatkan layanan kesehatan terbaik dengan konsultasi online bersama dokter berpengalaman kapan saja</p>
              <a href="#" class="btn">Mulai konsultasi</a>
            </div>
          </div>
        </div>
      </section>
    `;

		blockManager.add(blockId, {id: blockId, label, category, content: html});

		return {id: blockId, ns};
	};

	// Daftarkan template 4
	addTemplate4({
		id: "hero-16x9-gradient-right",
		label: `
      <div class="bg-secondary h-8 mb-4 rounded text-dark">Template 4</div>
      <div>Text Left, Doctor Right + Gradient</div>
    `,
		category: "Default Banner",
		image: "https://cdn.promedik.com/dokter-banner.png",
	});

	// Daftarkan template 5
	addTemplate5({
		id: "hero-16x9-gradient-left",
		label: `
      <div class="bg-secondary h-8 mb-4 rounded text-dark">Template 5</div>
      <div>Doctor Left, Text Right + Gradient</div>
    `,
		category: "Default Banner",
		image: "https://cdn.promedik.com/dokter-banner.png",
	});

	blockManager.add("default", {
		id: "default",
		label: `<div class="bg-secondary  h-8 mb-4 rounded text-dark">Default</div>
                    <div>Banner</div>`,
		category: "Default Banner",
		content: `<div
                        class="banner-container"
                        style="background-image: url(https://cdn.promedik.com/bg-banner.png)">
                        <h1
                            style="color: white; font-weight: 800; fontSize: 52px; position: absolute; top: 18%; left: 15%;">
                            <i>
                                Jadwalkan Konsultasi Online <br /> Dengan Dokter Favoritemu
                            </i>
                        </h1>
                        <a
                            style="padding-left: 24px; padding-right: 24px; padding-top: 12px; padding-bottom: 12px; background: rgba(255, 255, 255, 0.4); border-radius: 25px; color: white; position: absolute; top: 50%; left: 15%;"
                        >
                            Lihat Detail
                        </a>
                        <p style="color: white; position: absolute; top: 60%; left: 15%;">*S&K Berlaku</p>
                        <div style="position: absolute; top: 60%; left: 42%">
                            <div style="position: relative">
                                <p
                                    style="display: inline; color: white; font-weight: 800; font-size: 24px; margin-top: 0">
                                    PROMO
                                </p>
    
                                <div style="position: absolute; right: -90px; top: 8px;">
                                    <div style="position: relative">
                                        <h1
                                            style="color: white; fontWeight: 800; fontSize: 78px; margin: 0; transform: scale(1.8); marginLeft: 20%;"
                                        >
                                            40
                                        </h1>
                                        <img
                                            alt="disc"
                                            src="https://cdn.promedik.com/disc.png"
                                            style="position: absolute; right: -70px; top: -30px"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <img
                            alt="banner"
                            class=""
                            src="https://cdn.promedik.com/dokter-banner.png"
                            style="position: absolute; bottom: 0%; right: 15%; height: 90%"
                        />
                    </div>`,
	});

	blockManager.add("default-description", {
		id: "default-description",
		label: `<div class="bg-secondary  h-8 mb-4 rounded text-dark">Default</div>
                    <div>Description</div>`,
		category: "Default Description",
		content: `<div class="container p-0">
				<h1 class="fw-bold mb-1 fz-5" style="fontSize: 28;">
					Diskon IVF dengan ProMil Rp20jt
				</h1>
				<p class="text-grey" style="fontSize: 16;">
					Until Desember 2024
				</p>
				<hr />

				<section class="mb-5">
					<h2 class="mb-4" style="fontSize: 18; fontWeight: 700;">
						Syarat & Ketentuan
					</h2>
					<h3 class="mb-3" style="fontSize: 14;">
						Paket ProMil
					</h3>
					<div>
						<p class="mb-3">
							Memiliki buah hati merupabawah ini, bahwa dengan persiapan yang optimal akan menaikkan
							angkapasangan dapat memiliki buah hati tengan mudah.
						</p>
						<p class="mb-0">Faktor keberhasilan Program Hamil dipengaruhi oleh:</p>
						<ul class="mb-3">
							<li>Faktor Suami 45%</li>
							<li>Faktor Istri 45%</li>
							<li>Unexplained Infertility 10%</li>
						</ul>

						<p class="mb-0">
							Untuk hamil, dibutuhkan pertemuan sel telur dan sel sperma yang kemudian harus menempel di
							rahim dengin sempurna. Hal itu data dicapai melalui metode:
						</p>
						<ul class="mb-3">
							<li>Hubungan Alami Suami-Istri</li>
							<li>Inseminasi Buatan (IUI)</li>
							<li>Bayi Tabung (IVF)</li>
						</ul>

						<p class="mb-3">
							Namun ketiga metode tersebut tidak akan memberikan hasil yang optimal bila tidak disertakan
							persiapan terhadap suami dan istri dalam rangkaian Persiapan Program Hamil. Kita lihat pada
							grafik di bawah ini, bahwa dengan persiapan yang optimal akan menaikkan angka kerberhasilln
							Program Hamil secara significan.
						</p>
					</div>
					<img
						alt="pregnancy-program-graph"
						class="w-100"
						src="https://cdn.promedik.com/pregnancy-program-graph.png"
					/>
				</section>

				<section>
					<p class="mb-4">Ikutilah paket Program Hamil untuk hasil yang optimal:</p>
					<div class="row gap-3 gap-xl-0">
						<div class="col-12 col-xl-4 pe-xl-2">
							<div class="card">
								<div class="card-body">
									<h3 class="h6 fw-normal">PAKET PROMIL</h3>
									<h4 class="h6 fw-bold">SILVER</h4>
									<p>Rp 9,9jt/bln selama 6 bulan</p>

									<ul>
										<li>Konsultasi Dokter Spesialis</li>
										<li>Pemeriksaan Sperma</li>
										<li>Pemeriksaan Hormon</li>
										<li>Obat-obatan Andrologi</li>
									</ul>

									<a
										class="d-block w-100 rounded-pill btn-orange border-orange mt-3 cursor-pointer"
										href="https://invoice.xendit.co/od/promilplatinum">
										DAFTAR PROMIL SILVER
									</a>
								</div>
							</div>
						</div>

						<div class="col-12 col-xl-4 px-xl-2">
							<div class="card">
								<div class="card-body">
									<h3 class="h6 fw-normal">PAKET PROMIL</h3>
									<h4 class="h6 fw-bold">GOLD</h4>
									<p>Rp 12,9jt/bln selama 6 bulan</p>

									<ul>
										<li>Konsultasi Dokter Spesialis</li>
										<li>Pemeriksaan Sperma</li>
										<li>Pemeriksaan Hormon</li>
										<li>Obat-obatan Andrologi</li>
										<li>
											<b>DNA Fragmentasi</b>
										</li>
										<li>
											<b>Pemeriksaan Alergi</b>
										</li>
										<li>
											<b>USG Testis</b>
										</li>
									</ul>

									<a
										class="d-block w-100 rounded-pill btn-orange border-orange mt-3 cursor-pointer"
										href="https://invoice.xendit.co/od/promilgold">
										DAFTAR PROMIL GOLD
									</a>
								</div>
							</div>
						</div>

						<div class="col-12 col-xl-4 ps-xl-2">
							<div class="card">
								<div class="card-body">
									<h3 class="h6 fw-normal">PAKET PROMIL</h3>
									<h4 class="h6 fw-bold">PLATINUM</h4>
									<p>Rp 14,9jt/bln selama 6 bulan</p>

									<ul>
										<li>Konsultasi Dokter Spesialis</li>
										<li>Pemeriksaan Sperma</li>
										<li>Pemeriksaan Hormon</li>
										<li>Obat-obatan Andrologi</li>
										<li>DNA Fragmentasi</li>
										<li>Pemeriksaan Alergi</li>
										<li>USG Testis</li>
										<li>
											<b>Akupuntur 24 Sesi (Suami dan Istri)</b>
										</li>
										<li>
											<b>Diskon Bayi Tabung (IVF) sebesar Rp20jt</b>
										</li>
									</ul>

									<a
										class="d-block w-100 rounded-pill btn-orange border-orange mt-3 cursor-pointer"
										href="https://invoice.xendit.co/od/promilsilver">
										DAFTAR PROMIL PLATINUM
									</a>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>`,
	});

	blockManager.add("custom-component-container", {
		id: "custom-component-container",
		label: `<div class="border rounded py-4"></div>
                    <div class="mt-2">Banner Container</div>`,
		category: "Custom Component",
		content: `<div class="banner-container"></div>`,
	});
	blockManager.add("custom-component-button", {
		id: "custom-component-button",
		label: `<div class="btn btn-orange py-2 mb-2">Click</div>
                    <div>Button</div>`,
		category: "Custom Component",
		content: `<a class="btn btn-orange w-100">Click</a>`,
	});
	blockManager.add("custom-component-text", {
		id: "custom-component-text",
		label: `<div class="mb-2 fs-3">Text</div>
                    <div>Text</div>`,
		category: "Custom Component",
		content: `<p class="p-0 m-0" style="position: absolute; line-height: auto; font-size: 24px;">Type here</p>`,
	});
	blockManager.add("custom-component-image", {
		id: "custom-component-image",
		label: `<img src="/img/no-image-post@2x.png" style="height: 20px;" />
                    <div class="mt-2">Image</div>`,
		category: "Custom Component",
		content: `<img src="" />`,
	});

	// UL
	blockManager.add("unordered-list-container", {
		id: "unordered-list-container",
		label: `<ul class="border rounded">
                    <li> --- </li>
                    <li> --- </li>
                    <li> --- </li>
                </ul>
                    <div class="mt-2">Un-ordered List Container</div>`,
		category: "Custom Component",
		content: `<ul class="pb-4">
                    <li> <p class="p-0 m-0">Type Here </p></li>
                </ul>
                `,
	});
	blockManager.add("unordered-list-item", {
		id: "unordered-list-item",
		label: `<ul>
                    <li> --- </li>
                    <li> --- </li>
                    <li> --- </li>
                </ul>
                    <div class="mt-2">Un-ordered List Item</div>`,
		category: "Custom Component",
		content: `<li>
                    <p class="p-0 m-0">Type Here </p>
                </li>`,
	});

	// Bordered Container
	blockManager.add("bordered-container", {
		id: "bordered-container",
		label: `<div class="py-2 border rounded"></div>
                    <div class="mt-2">Bordered Container</div>`,
		category: "Custom Component",
		content: `<div style="min-height: 40px;" class="border rounded-2"></div>`,
	});

	// HR
	blockManager.add("hr", {
		id: "hr",
		label: `<hr />
                    <div class="mt-2">Hr</div>`,
		category: "Custom Component",
		content: `<hr class="w-100" />`,
	});

	// Heading
	blockManager.add("h1", {
		id: "h1",
		label: `<h5>Heading 1</h5>
                <div class="mt-2">Heading 1</div>`,
		category: "Heading",
		content: `<h1>Heading 1</h1>`,
	});
	blockManager.add("h2", {
		id: "h2",
		label: `<h5>Heading 2</h5>
                <div class="mt-2">Heading 2</div>`,
		category: "Heading",
		content: `<h2>Heading 2</h2>`,
	});
	blockManager.add("h3", {
		id: "h3",
		label: `<h5>Heading 3</h5>
                <div class="mt-2">Heading 3</div>`,
		category: "Heading",
		content: `<h3>Heading 3</h3>`,
	});
	blockManager.add("h4", {
		id: "h4",
		label: `<h5>Heading 4</h5>
                <div class="mt-2">Heading 4</div>`,
		category: "Heading",
		content: `<h4>Heading 4</h4>`,
	});
	blockManager.add("h5", {
		id: "h5",
		label: `<h5>Heading 5</h5>
                <div class="mt-2">Heading 5</div>`,
		category: "Heading",
		content: `<h5>Heading 5</h5>`,
	});
	blockManager.add("h6", {
		id: "h6",
		label: `<h5>Heading 6</h5>
                <div class="mt-2">Heading 6</div>`,
		category: "Heading",
		content: `<h6>Heading 6</h6>`,
	});
}
